import React from "react";
const MainLayout = ({ children, ...rest }) => {
   //console.log("value",children)
   return (
      <div>
        {children}
      </div>
   );
};
export default MainLayout;
